import React, { type JSX } from 'react';
import FaIcon, { IFaIcon } from './FaIcon.tsx';
import { BaseTooltip } from '@cks-internal/react-base';

interface IFaIconWithToolTip extends IFaIcon {
  tooltip: string | JSX.Element;
}

const FaIconWithToolTip: React.FC<IFaIconWithToolTip> = (props: IFaIconWithToolTip) => {
  return (
    <BaseTooltip content={props.tooltip}>
      <FaIcon {...props} />
    </BaseTooltip>
  );
};

export default FaIconWithToolTip;
